<svg
    aria-labelledby={$$props.id + "_title"}
    aria-describedby={$$props.id + "_desc"}
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <title id={$$props.id + "_title"}>calendrier</title>
    <desc id={$$props.id + "_desc"}>calendrier</desc>
    <path
        d="M0.799988 2.61978C0.799988 1.89978 1.35999 1.31978 2.03999 1.31978H10.76C11.45 1.31978 12 1.89978 12 2.61978V11.7198C12 12.4398 11.44 13.0198 10.76 13.0198H2.03999C1.34999 13.0198 0.799988 12.4398 0.799988 11.7198V2.61978ZM2.03999 3.91978V11.7198H10.76V3.91978H2.03999ZM3.28999 0.0197754H4.52999V1.31978H3.28999V0.0197754ZM8.26999 0.0197754H9.50999V1.31978H8.26999V0.0197754ZM3.28999 5.86978H4.52999V7.16978H3.28999V5.86978ZM3.28999 8.46978H4.52999V9.76978H3.28999V8.46978ZM5.77999 5.86978H7.01999V7.16978H5.77999V5.86978ZM5.77999 8.46978H7.01999V9.76978H5.77999V8.46978ZM8.26999 5.86978H9.50999V7.16978H8.26999V5.86978ZM8.26999 8.46978H9.50999V9.76978H8.26999V8.46978Z"
        fill="#575757"
    />
</svg>
